module.exports = __webpack_public_path__ + "static/media/Kahoot Lobby Music (HD).10a6cd28.mp3";